export default __webpack_public_path__ + "static/media/favourite-strings-icon.54c4585d.svg";